export default __webpack_public_path__ + "images/fb0f1494eda5af9e6b872b8d27d35392-iconos_twitter.svg";